<template>
<div>
  <progress-loader customClass="pull-right" customStyle="width:100px; margin-top: -45px" ref="progress"></progress-loader>
  <div style="height:320px; overflow-y:auto; overflow-x:hidden">
    <ul class="icons-list visitor">
      <li v-for="visitor in visitorExceeded" v-bind:key="visitor.name" v-if="visitorExceeded.length > 0">
        <i class="icon-clock bg-danger btn-pill" ></i>
        <div class="desc">
          <div class="title font-weight-bold">{{ visitor.name }}</div>
          <small><b>{{visitor.visitorStatus}}</b> at {{visitor.visitStartTime}}</small>
        </div>
        <div class="actions">
          <b-button :href="'#/visitor/' + visitor.uuid + '?redirect=%2Fdashboard'" variant="link" class="text-muted"><i class="icon-list"></i></b-button>
        </div>
      </li>
      <li class="text-center" style="padding:100px 0px" v-if="visitorExceeded.length == 0">
        <h5 class="text-muted">Can't load data for a while</h5>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import progressLoader from '@/views/components/progressLoader'

export default {
  name: 'visitorExceeded',
  components: {
    progressLoader
  },
  props: {
    method1: null
  },
  data () {
    return {
      apiUrlGetvisitorExceeded: window.AppConfig.apiUrl + 'visitor-exceed-time?order=visitStartTime&ascending=1',
      visitorExceeded: [],
      visitorExceededCount: 0
    }
  },
  mounted () {
    var self = this
    setTimeout(function () {
      try {
        self.getList()
      } catch (err) {
        self.getList()
      }
      self.doAutoRefresh()
    }, Math.floor(Math.random() * 1200) + 1000)
  },
  beforeDestroy () {
    clearInterval(this.refVisitorExceeded)
  },
  methods: {
    getList () {
      this.$refs.progress.activateProgressBar()
      axios.get(this.apiUrlGetvisitorExceeded)
        .then(response => {
          if (response === undefined) return false
          this.$refs.progress.deactivateProgressBar()
          if (response !== undefined) {
            this.visitorExceeded = response.data._embedded.visitorExceedTime
            for (let i = 0; i < this.visitorExceeded.length; i++) {
              this.visitorExceeded[i]['visitStartTime'] = moment(this.visitorExceeded[i]['visitStartTime']).fromNow()
            }
          } else {
            this.visitorExceeded = []
          }
          this.method1(response.data.total_items)
        })
        .catch(error => {
          this.$refs.progress.deactivateProgressBar()
          this.visitorExceeded = []
          this.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              this.$alertify.error(errMsg)
            })
        })
    },
    getVisitorExCount () {
      return this.visitorExceedCount
    },

    doAutoRefresh () {
      this.refVisitorExceeded = setInterval(() => {
        this.getList()
      }, window.AppConfig.IntervalRefreshDataDashboard)
    }
  }

}
</script>


<style>
.desc, .value {
    padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/visitorExceeded.vue